import { Helmet } from 'react-helmet'

export default function About() {

    // const services = [
    //     {
    //         icon: "🚀",
    //         color: "blue",
    //         title: "Our Vision",
    //         description:
    //             "To be a trusted partner in the Title and Settlement Services industry by delivering innovative, precise, and dependable process solutions that drive long-term success for our clients.",
    //         features: [
    //             "Set new standards in accuracy and turnaround time",
    //             "Build lasting partnerships through trust and transparency",
    //             "Leverage technology for smarter, more efficient workflows",
    //             "Continuously evolve with industry regulations and market needs",
    //             "Be recognized for reliability, consistency, and service excellence",
    //         ],
    //         image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&auto=format&fit=crop&w=900&q=80",
    //     },
    //     {
    //         icon: "🎯",
    //         color: "indigo",
    //         title: "Our Mission",
    //         description:
    //             "Our mission is to support mortgage lenders, title companies, and real estate professionals with streamlined, compliant, and detail-driven services that enhance operational efficiency and reduce risk.",
    //         features: [
    //             "Deliver high-quality title and mortgage support services",
    //             "Maintain strict compliance with US industry standards",
    //             "Ensure data accuracy and secure information handling",
    //             "Provide responsive communication and dedicated support",
    //             "Continuously improve processes through training and innovation",
    //         ],
    //         image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&auto=format&fit=crop&w=900&q=80",
    //     },
    // ];

    const services = [
        {
            icon: "🚀",
            color: "blue",
            title: "Our Vision",
            description:
                "Our vision is to become a highly trusted and long-term strategic partner in the Title and Settlement Services industry. We aim to deliver innovative, precise, and dependable process solutions that empower title agencies, lenders, and real estate professionals to operate with confidence, clarity, and measurable efficiency.",
            features: [
                "Set new industry benchmarks for accuracy, compliance, and turnaround time",
                "Build enduring partnerships rooted in trust, transparency, and accountability",
                "Leverage modern technology to create smarter, automated, and scalable workflows",
                "Continuously adapt to evolving industry regulations, compliance standards, and market dynamics",
                "Be widely recognized for operational excellence, reliability, and consistent service delivery",
            ],
            image:
                "https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&auto=format&fit=crop&w=900&q=80",
        },
        {
            icon: "🎯",
            color: "indigo",
            title: "Our Mission",
            description:
                "Our mission is to support mortgage lenders, title companies, and real estate professionals with streamlined, compliant, and detail-driven services that enhance operational efficiency, reduce transactional risk, and strengthen client confidence throughout every stage of the closing process.",
            features: [
                "Deliver consistently high-quality title and mortgage support services with precision and accountability",
                "Maintain strict adherence to U.S. industry standards, underwriter guidelines, and regulatory requirements",
                "Ensure exceptional data accuracy, confidentiality, and secure handling of sensitive client information",
                "Provide proactive communication, responsive turnaround times, and dedicated client support",
                "Continuously refine and improve internal processes through structured training, quality control, and innovation",
            ],
            image:
                "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&auto=format&fit=crop&w=900&q=80",
        },
    ];

    const stats = [
        { value: "500+", label: "Clients Served" },
        { value: "99%", label: "Accuracy Rate" },
        { value: "10+", label: "Years Experience" },
        { value: "24/7", label: "Support Available" },
    ];

    return (
        <div className="bg-white">
            <Helmet>
                <meta charSet="utf-8" />
                <title>CityPulse LLC | About</title>
                <link rel="canonical" href="https://citypulsellc.com/about" />
            </Helmet>

            {/* ── HERO ── */}
            <section className="relative min-h-[60vh] flex flex-col justify-center overflow-hidden bg-gray-950">

                {/* Background */}
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{
                        backgroundImage: `url('https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')`
                    }}
                />
                <div className="absolute inset-0 bg-gradient-to-r from-gray-950/85 via-gray-900/70 to-blue-900/50" />

                {/* Decorative blobs + dot grid */}
                <div className="absolute inset-0 overflow-hidden pointer-events-none">
                    <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full bg-blue-500/20 blur-3xl" />
                    <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-indigo-500/10 blur-3xl" />
                    <div
                        className="absolute inset-0 opacity-10"
                        style={{
                            backgroundImage: `radial-gradient(circle, #fff 1px, transparent 1px)`,
                            backgroundSize: `32px 32px`,
                        }}
                    />
                </div>

                <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 w-full">

                    {/* Eyebrow */}
                    <div className="flex items-center gap-3 mb-6">
                        <span className="inline-flex items-center gap-2 bg-white/10 border border-white/20 backdrop-blur-sm rounded-full px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-blue-300">
                            <span className="w-2 h-2 rounded-full bg-blue-400 animate-pulse" />
                            Who We Are
                        </span>
                    </div>

                    {/* Headline */}
                    <h1 className="text-5xl sm:text-6xl lg:text-7xl font-black text-white leading-none mb-6 max-w-2xl">
                        About
                        <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-300 mt-1">
                            City Pulse
                        </span>
                    </h1>

                    {/* Divider */}
                    <div className="flex items-center gap-4 mb-6">
                        <div className="h-px w-16 bg-gradient-to-r from-blue-400 to-transparent" />
                        <div className="w-2 h-2 rounded-full bg-blue-400" />
                        <div className="w-2 h-2 rounded-full bg-blue-400" />
                    </div>

                    {/* Description */}
                    <p className="text-lg sm:text-xl text-gray-300 max-w-2xl leading-relaxed mb-12">
                        Delivering comprehensive Title and Settlement Services solutions with a commitment to precision, reliability, and long-term industry trust.
                    </p>

                    {/* Stats */}
                    {/* <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-2xl">
                        {stats.map((stat, i) => (
                            <div
                                key={i}
                                className="bg-white/5 border border-white/10 backdrop-blur-sm rounded-2xl px-4 py-4 text-center hover:bg-white/10 transition-colors duration-200"
                            >
                                <div className="text-2xl font-black text-white">{stat.value}</div>
                                <div className="text-xs text-gray-400 mt-0.5 font-medium">{stat.label}</div>
                            </div>
                        ))}
                    </div> */}

                    {/* Scroll hint */}
                    <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-40">
                        <span className="text-white text-xs uppercase tracking-widest">Scroll</span>
                        <div className="w-px h-8 bg-gradient-to-b from-white to-transparent animate-bounce" />
                    </div>
                </div>
            </section>

            {/* ── VISION & MISSION ── */}
            <section className="py-20 bg-gray-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                    {/* Section label */}
                    <div className="flex items-center gap-3 mb-3">
                        <div className="h-px w-10 bg-blue-600" />
                        <span className="text-xs font-bold uppercase tracking-widest text-blue-700">Our Purpose</span>
                    </div>
                    <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
                        Who We Are {/* What Drives Us */}
                    </h2>

                    <p className="text-gray-500 mb-5">Delivering comprehensive Title and Settlement Services solutions with an unwavering commitment to precision, regulatory compliance, operational excellence, and long-term industry trust. We help our partners navigate complex transactions with confidence and clarity. With a strong understanding of title insurance procedures, settlement workflows, and regulatory requirements, our team provides structured support across title commitments, curative services, tax services, settlement coordination, and document processing. Every file we handle is approached with precision, confidentiality, and strict quality control standards.</p>
                    <p className="text-gray-500 mb-12">Our goal is to reduce risk, improve turnaround times, and allow our clients to focus on growth while we manage the operational details behind the scenes. We combine industry expertise, structured workflows, and technology-driven processes to deliver scalable solutions tailored to each client’s needs. From initial order entry to final documentation and closing support, our team ensures every step is completed with clarity and accountability. At City Pulse, we believe that strong back-office operations are the foundation of smooth and successful real estate transactions.</p>

                    <div className="space-y-16">
                        {services.map((service, index) => (
                            <div
                                key={index}
                                className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-8 xl:gap-14 items-stretch`}
                            >
                                {/* Content Card */}
                                <div className="flex-1 bg-white rounded-3xl p-7 sm:p-9 shadow-sm border border-gray-100 hover:shadow-lg transition-shadow duration-300 flex flex-col">

                                    {/* Icon badge */}
                                    <div className="flex items-center gap-4 mb-6">
                                        <div className="w-14 h-14 bg-blue-50 rounded-2xl flex items-center justify-center text-3xl flex-shrink-0">
                                            {service.icon}
                                        </div>
                                        <div>
                                            <p className="text-xs font-bold uppercase tracking-widest text-blue-600 mb-0.5">City Pulse</p>
                                            <h2 className="text-2xl sm:text-3xl font-black text-gray-900">{service.title}</h2>
                                        </div>
                                    </div>

                                    {/* Divider */}
                                    <div className="h-px bg-gray-100 mb-6" />

                                    {/* Description */}
                                    <p className="text-gray-500 leading-relaxed mb-6 text-sm sm:text-base">
                                        {service.description}
                                    </p>

                                    {/* Features */}
                                    <ul className="space-y-3 flex-1">
                                        {service.features.map((feature, fi) => (
                                            <li key={fi} className="flex items-start gap-3">
                                                <div className="flex-shrink-0 mt-0.5 w-5 h-5 rounded-full bg-blue-50 flex items-center justify-center">
                                                    <svg className="w-3 h-3 text-blue-600" viewBox="0 0 12 12" fill="none">
                                                        <path d="M2 6l3 3 5-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </div>
                                                <span className="text-sm text-gray-600 leading-relaxed">{feature}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>

                                {/* Image Panel */}
                                <div className="flex-1 min-h-[280px] sm:min-h-[360px] rounded-3xl overflow-hidden relative shadow-lg">
                                    <img
                                        src={service.image}
                                        alt={service.title}
                                        className="absolute inset-0 w-full h-full object-cover"
                                    />
                                    {/* Gradient overlay */}
                                    <div className={`absolute inset-0 bg-gradient-to-br from-blue-900/50 to-indigo-900/40`} />

                                    {/* Floating stat pill */}
                                    <div className="absolute bottom-6 left-6 right-6">
                                        <div className="bg-white/15 backdrop-blur-md border border-white/25 rounded-2xl px-5 py-4 flex items-center gap-4">
                                            <div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center text-2xl flex-shrink-0">
                                                {service.icon}
                                            </div>
                                            <div>
                                                <p className="text-white font-bold text-sm">{service.title}</p>
                                                <p className="text-white/70 text-xs mt-0.5">City Pulse LLC</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className='pt-5 lg:pt-10'>
                        <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
                            What Drives Us
                        </h2>
                        <div className="max-w-7xl mx-auto space-y-3">
                            {[
                                {
                                    title: "Accuracy First",
                                    desc: "Every document, search, and report undergoes detailed review to ensure compliance and reliability.",
                                    icon: "✓",
                                },
                                {
                                    title: "Regulatory Compliance",
                                    desc: "We operate in full alignment with U.S. title and mortgage industry standards.",
                                    icon: "⚖️",
                                },
                                {
                                    title: "Confidentiality & Security",
                                    desc: "Client data is handled with strict security protocols and the highest level of discretion.",
                                    icon: "🔒",
                                },
                                {
                                    title: "Timely Delivery",
                                    desc: "We understand the importance of deadlines in real estate transactions and deliver on time.",
                                    icon: "⏱️",
                                },
                                {
                                    title: "Long-Term Partnerships",
                                    desc: "We build trust, transparency, and consistent performance to grow together with our clients.",
                                    icon: "🤝",
                                },
                            ].map((item, i) => (
                                <div key={i} className="group flex items-center gap-3 transition-all duration-300"  >
                                    {/* Icon */}
                                    <div className="h-2 w-2 rounded-full bg-black" />
                                    <p className="text-gray-600 leading-relaxed">
                                        <span className="text-lg font-semibold text-gray-900 mb-2 tracking-tight">{item.title} -</span>     {item.desc}
                                    </p>
                                </div>
                            ))}
                        </div>



                    </div>

                </div>

            </section>



            {/* ── CTA SECTION ── */}
            <section className="relative py-20 overflow-hidden bg-gray-950">
                <div className="absolute inset-0 overflow-hidden pointer-events-none">
                    <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full bg-blue-500/20 blur-3xl -translate-y-1/2 translate-x-1/2" />
                    <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-indigo-500/15 blur-3xl translate-y-1/2 -translate-x-1/4" />
                    <div
                        className="absolute inset-0 opacity-5"
                        style={{
                            backgroundImage: `radial-gradient(circle, #fff 1px, transparent 1px)`,
                            backgroundSize: `28px 28px`,
                        }}
                    />
                </div>

                <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <span className="inline-block text-xs font-bold uppercase tracking-widest text-blue-400 mb-4">
                        Let's Work Together
                    </span>
                    <h2 className="text-4xl sm:text-5xl font-black text-white mb-4 leading-tight">
                        Ready to Get Started?
                    </h2>
                    <div className="w-16 h-1 bg-gradient-to-r from-blue-400 to-indigo-300 rounded-full mx-auto mb-6" />
                    <p className="text-lg text-gray-400 mb-10 max-w-xl mx-auto leading-relaxed">
                        Contact us today to learn how City Pulse can support your mortgage processing needs.
                    </p>
                    <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                        <a
                            href="/contact"
                            className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-semibold py-3.5 px-8 rounded-xl transition-all duration-200 hover:scale-105 shadow-xl shadow-primary/30 text-sm"
                        >
                            Contact Us
                            <svg className="w-4 h-4" viewBox="0 0 16 16" fill="none">
                                <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </a>
                        <a
                            href="/services"
                            className="inline-flex items-center gap-2 border border-white/20 hover:border-white/40 text-gray-300 hover:text-white font-semibold py-3.5 px-8 rounded-xl transition-all duration-200 text-sm"
                        >
                            View Our Services
                        </a>
                    </div>
                </div>
            </section>
        </div>
    )
}